import { Dispatch, PropsWithChildren, SetStateAction } from 'react';

import { DragAndDropProps } from '../../models/drag-and-drop.model';

export const callbackFunction = (
  setFiles: Dispatch<SetStateAction<File[]>>,
  props: PropsWithChildren<DragAndDropProps>
): ((file: File) => void) => {
  return (file: File): void => {
    setFiles(prevState => {
      if (!props.multiple) {
        return [file];
      }
      return prevState.concat(file);
    });
  };
};
